import { cloneDeep, toInteger } from 'lodash';
import { v4 as uuid } from 'uuid';
import { isEmptyEffect } from '@meitu/saas-editor-core/es/utils/layer-kit';
import {
    IExtraInfo,
    IImageEffectProps,
    IImageLayerProps,
    ILayerProps,
    LayerType,
} from '@meitu/saas-editor-core/es/version-types';
import { getLocaleStore } from '@/i18n';
import { editor } from '@/instance';
import { renderImageEffectToUrl } from '@/utils/render-image-effect';

editor.contextMenu.onSaveToMySpace(() => {
    addToMySpace();
});

export const addToMySpace = async () => {};

export const addToStage = async (
    layerParam: ILayerProps,
    fitWithStage = false,
    fixedCenter = false,
    byMousePosition = false,
) => {
    const { $t } = getLocaleStore();
    try {
        editor.services.mask.show({
            loading: true,
            text: $t((v) => v.collapse.tips.addLoading),
        });

        const activeStageIndex = editor.services.frame.getActiveIndex();
        const { width: stageWidth, height: stageHeight } = editor.services.frame.getSizeByIndex(activeStageIndex);
        const layer = cloneDeep(layerParam);

        // 设置layer的parentId, id
        const resetLayer = (layer: ILayerProps, parentId?: string) => {
            layer.id = uuid();
            if (parentId) {
                layer.parentId = parentId;
            } else {
                delete layer.parentId;
            }

            layer.children.forEach((item) => {
                resetLayer(item, layer.id);
            });
        };
        resetLayer(layer);

        if (fitWithStage) {
            const prevLayerWidth = layer.width;
            const prevLayerHeight = layer.height;

            const widthRatio = prevLayerWidth / stageWidth;
            const heightRatio = prevLayerHeight / stageHeight;

            const scaleDistance = (() => {
                if (widthRatio > heightRatio) {
                    return stageWidth / 2 - layer.width;
                }
                return layer.width / heightRatio / 2 - layer.width;
            })();

            editor.services.frame.scaleLayer(layer, scaleDistance, undefined, undefined, true); // 添加表格缩放参数

            // 如果有特效图层还要重新做一次特效
            if (layer && layer.layerType === LayerType.IMAGE_LAYER && !isEmptyEffect(layer.data as IImageLayerProps)) {
                const url = await renderImageEffectToUrl(layer);
                if (url && (layer.data as IImageLayerProps).effect) {
                    ((layer.data as IImageLayerProps).effect as IImageEffectProps).screenshotUrl = url;
                }
            }
        }

        const centerPoint = {
            x: toInteger(stageWidth / 2),
            y: toInteger(stageHeight / 2),
        };

        // 同步vip信息
        let extraInfo:
            | {
                  oldExtraInfo: IExtraInfo;
                  newExtraInfo: IExtraInfo;
              }
            | undefined;
        if (layer.extraInfo) {
            const activeStageIndex = editor.services.frame.getActiveIndex();
            const activeStageExtraInfo = editor.services.frame.getExtraInfo(activeStageIndex);
            const threshold = !!activeStageExtraInfo.threshold || !!layer.extraInfo?.threshold;
            extraInfo = {
                oldExtraInfo: activeStageExtraInfo,
                newExtraInfo: {
                    ...layer.extraInfo,
                    threshold: threshold ? 1 : 0,
                },
            };
            console.log('===extraInfo', extraInfo);
        }
        if (fixedCenter) {
            editor.layer.addByStagePoint(
                {
                    layer,
                    extraInfo,
                },
                centerPoint,
            );
        } else if (byMousePosition) {
            editor.layer.addByMousePosition({
                layer,
                extraInfo,
            });
        } else {
            editor.layer.addByDiagonal({
                layer,
                extraInfo,
            });
        }
    } catch (error) {
        console.log(error);
    } finally {
        editor.services.mask.hide();
    }
};
